<template>
  <div
    class="control-pane"
    v-bind:class="{ hideable }"
  >
    <button
      class="button button-icon button-icon-full"
      v-on:click="$emit('toggleFullScreen')"
    >
      <fullscreen-icon
        class="icon"
        v-bind:enabled="isFullscreenMode"
        v-bind:class="fullscreenClass"
      />
      <!-- <i
        class="icon"
        v-bind:class="isFullscreenMode ? 'icon__fullscreen-off' : 'icon__fullscreen'"
      ></i> -->
    </button>

    <!-- <button
      class="button button-icon"
      v-on:click="$emit('showRatingTable')"
      v-show="allowedRatingTable"
    >
      <i class="icon icon__rating-page"></i>
    </button> -->

    <button
      class="button button-icon button-icon-full"
      v-on:click="$emit('toggleVolume')"
    >
      <volume-icon
        class="icon"
        v-bind:enabled="volumeOn"
        v-bind:class="volumeClass"
      />

      <!-- <i class="icon"
        v-bind:class="volumeClass"
      ></i> -->
    </button>

    <button
      class="button button-icon button-icon-full"
      v-on:click="$emit('showAnswerForm')"
      v-show="allowedAnswerForm"
    >
      <i class="icon icon__answer-list"></i>
    </button>
  </div>
</template>

<script>
import VolumeIcon from './shared/icons/VolumeIcon.vue';
import FullscreenIcon from './shared/icons/FullscreenIcon.vue';

export default {
  name: 'ControlPane',

  components: {
    FullscreenIcon,
    VolumeIcon,
  },

  props: {
    allowedAnswerForm: {
      type: Boolean,
      default: false,
    },

    allowedRatingTable: {
      type: Boolean,
      default: true,
    },

    isDebug: {
      type: Boolean,
      default: false,
    },

    isFullscreenMode: {
      type: Boolean,
      default: false,
    },

    volumeOn: {
      type: Boolean,
      default: false,
    },

    hideable: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    volumeClass() {
      return this.volumeOn
        ? 'icon__volume-on'
        : 'icon__volume-off';
    },

    fullscreenClass() {
      return this.isFullscreenMode
        ? 'icon__fullscreen-off'
        : 'icon__fullscreen';
    },
  },
};
</script>
